import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
  Label,
} from "reactstrap";
import Utils from "../Utility";
import { post, get, put, upload } from "../../helpers/api_helper";
import DeleteModal from "./DeleteModal";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import UserProfile from "../../components/UserProfile";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Loader from "../../components/Loader";
import Resizer from "react-image-file-resizer";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";

const Table = (props) => {
  const { user } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [isAddForm, setIsAddForm] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);

  const getData = () => {
    setLoading(true); // Set loading state to true when making the API request
    get("/contact/table", { token: user?.token })
      .then((json) => {
        // console.log("response from get project list", json);
        setLoading(false);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error while getting project list", error);
      });
  };

  // console.log("get inquiry data =============>", data);

  useEffect(() => {
    setColumns([
      {
        name: "Position",
        cell: (row, index) => (
          <>
            <Draggable key={row._id} draggableId={row._id} index={index}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  <i
                    className="mdi mdi-menu"
                    style={{ fontSize: 20, color: Utils.themeColor }}
                  ></i>
                </div>
              )}
            </Draggable>
          </>
        ),
        maxWidth: "50px",
      },
      {
        name: "Title",
        selector: (row) => row?.title,
      },
      {
        name: "Member",
        selector: (row) => row?.member?.length,
        maxWidth: "100px",
      },
      {
        cell: (row) => (
          <div className="table_btn">
            <button
              onClick={() => handleUpdateStatus(row)}
              className={row?.isActive ? "active_status" : "inactive_status"}
            >
              <span className="text-white" style={{}}>
                {row?.isActive ? "Active" : "Inactive"}
              </span>
            </button>
          </div>
        ),
        name: "Status",
        ignoreRowClick: true,
        maxWidth: "120px",
        sortable: true,
      },
      {
        cell: (row) => (
          <>
            <div className="action_btn table_btn">
              <button
                onClick={() => handleUpdateProj(row)}
              >
                <i class="mdi mdi-pencil"></i>
              </button>
              <button
                onClick={() => handleDeleteProj(row)}
              >
                <i class="mdi mdi-delete"></i>
              </button>
            </div>
          </>
        ),
        name: "Action",
        ignoreRowClick: true,
        maxWidth: "120px",
      },
    ]);
  }, [data]);

  useEffect(() => {
    if (!isAddForm && !deleteModal) {
      setCurrentData(null);
    }
  }, [isAddForm, deleteModal]);

  const handleUpdateProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData(proj);
    setIsAddForm(true);
  };

  const handleUpdateStatus = (item) => {
    setCurrentData({ ...item, actionType: "Status" });
    setDeleteModal(true);
  };

  const handleDeleteProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData({ ...proj, actionType: "Delete" });
    setDeleteModal(true);
  };

  const onDelete = () => {
    let body = {
      tableId: currentData?._id,
      token: user?.token
    };
    if (currentData?.actionType == "Status")
      body = { ...body, isActive: !currentData?.isActive }
    else
      body = { ...body, isDeleted: true }
    put("/contact/table", body)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          setDeleteModal(false);
          getData();
          props?.setCurrentData(null);
        } else {
          toast.error(res?.error);
        }
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  };

  const handleDragEnd = (result) => {
    console.log("dragging item", result);
    // Handle the drag-and-drop logic here
    if (!result.destination) return; // Item was dropped outside the list
    const items = [...data];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let ids = [],
      position = [];
    items.forEach((item, index) => {
      ids.push(item?._id);
      position.push(index);
    });
    let body = {
      ids,
      position,
      token: user?.token,
    };
    put("/contact/table/position", body).then((res) => {
      // if (res?.statusCode == 200)
      setData(items);
    });
  };

  const handleValidSubmit = async (e, v) => {
    console.log("values", v);
    let body = {
      ...v,
      token: user?.token,
    };
    setLoading(true);
    if (currentData) {
      body = { ...body, tableId: currentData?._id };
      put("/contact/table", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      post("/contact/table", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentData}
          />
          <Modal isOpen={isAddForm} centered={true} style={{ maxWidth: 800 }}>
            <ModalBody className="py-3 px-5">
              <h5 className="text-black font-size-20">
                {currentData ? `Update Table` : `Add New Table`}
              </h5>
              <div className="p-2">
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={handleValidSubmit}
                >
                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <AvField
                          name="title"
                          label="Table Title *"
                          className="form-control"
                          placeholder="Enter table title"
                          type="text"
                          required
                          value={currentData?.title}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="mt-4">
                    <Row>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                          onClick={() => {
                            setIsAddForm(false);
                          }}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                        >
                          {currentData ? "Update" : "Add"}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>

          <Col className="col-12">
            <div className="table_top_header">
              <Row style={{ width: '100%' }}>
                <Col md={11}>
                  Contact - Table
                </Col>
                <Col md={1}>
                  <div className="add_btn" onClick={() => setIsAddForm(true)}>
                    <i className="mdi mdi-plus" />
                  </div>
                </Col>
              </Row>
            </div>
            <Card style={{ borderRadius: "0" }} className="table-body-section">
              <CardBody>
                <div className="table-search-section">
                  {/* <div className="search_field">
                    <label>Search :</label>
                    <input
                      type="text"
                      value={""}
                      onChange={(e) => handleFilter(e.target.value)}
                    />
                  </div> */}
                </div>
                <Loader visible={loading} />
                {loading && <div>Loading...</div>}
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="table">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        <DataTable
                          columns={columns}
                          data={data}
                          pagination
                          // expandableRows
                          // expandableRowsComponent={ExpandedComponent}
                          // onRowClicked={(row) => handleExpandRow(row)}
                          // expandOnRowClicked
                          // isRowExpandable={(row) => true}
                          // isRowExpanded={isRowExpanded}
                          paginationPerPage={100}
                          paginationRowsPerPageOptions={[100, 200, 300, 400]}
                          conditionalRowStyles={[
                            {
                              when: (row) => row?.style,
                              style: (row) => ({ width: row?.style?.width }),
                            },
                          ]}
                          customStyles={{
                            headCells: {
                              style: {
                                color: "black",
                                fontWeight: "bold",
                                fontSize: 15,
                                width: 0,
                              },
                            },
                            cells: {
                              style: {
                                width: 0,
                              },
                            },
                          }}
                        />
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Table;
